import Text from '@cartwhl/ui/base/Text';

import { BLOG_ARTICLE_CDN_BASE } from './cdn';

interface ArticleImageProps {
  cdnKey: string;
  alt: string;
  caption?: string;
}

export default function ArticleImage({
  cdnKey,
  alt,
  caption,
}: ArticleImageProps) {
  return (
    <figure className="article-breakout my-8 px-4 lg:my-12 lg:px-0">
      <img
        src={`${BLOG_ARTICLE_CDN_BASE}${cdnKey}`}
        alt={alt}
        className="w-full rounded-2xl"
        loading="lazy"
      />
      {caption && (
        <figcaption className="article-caption mx-auto mt-3 px-4">
          <Text
            as="span"
            variant="web/body/medium/xs"
            className="text-tertiary"
          >
            {caption}
          </Text>
        </figcaption>
      )}
    </figure>
  );
}
